export default __webpack_public_path__ + "static/media/car-pause_40px.fa23feb0.svg";